<template>
  <div>
    <div v-if="order" class="highlighted highlighted--total">
      <SfProperty :name="$t('Order_No')" :value="(orderGetters.getId(order) || order.order_id)"
        class="sf-property--full-width property" />
      <SfProperty :name="$t('Order_Date')" :value="(order.createTime || order.create_time)
        ? getCuurentDate(orderGetters.getDate(order) || order.create_time)
        : ''
        " class="sf-property--full-width property" />
      <SfProperty :name="$t('Order_Status')" :value="$t(orderGetters.getStatus(order))"
        class="sf-property--full-width property" />
      <SfProperty :name="$t('Total')" :value="$n((order.transAmount || order.payment), {
        style: 'currency',
        currency: (order.transCurrency || order.trans_currency),
      })
        " class="sf-property--full-width property" />
      <SfProperty v-if="getInsuranceFee(order)>0" :name="$t('payment_insurance_fee')" :value="$n(getInsuranceFee(order), {
        style: 'currency',
        currency: (order.transCurrency || order.trans_currency),
      })
        " class="sf-property--full-width property" />
      <SfProperty v-if="getInsuranceTax(order) > 0" :name="$t('payment_insurance_tax')" :value="$n(getInsuranceTax(order), {
        style: 'currency',
        currency: (order.transCurrency || order.trans_currency),
      })
        " class="sf-property--full-width property" />
      <SfProperty :name="$t('payment_post_fee')" :value="$n(order.postFee, {
        style: 'currency',
        currency: (order.transCurrency || order.trans_currency),
      })
        " class="sf-property--full-width property" />
      <SfProperty v-if="order.postFeeTax>0" :name="$t('payment_post_tax')" :value="$n(order.postFeeTax, {
        style: 'currency',
        currency: (order.transCurrency || order.trans_currency),
      })
        " class="sf-property--full-width property" />
      <SfProperty :name="$t('order_shopping_firstname')" :value="getShippingMemberName(order)"
        class="sf-property--full-width property" />
      <SfProperty :name="$t('MyAccount_MyShippingDetails_Phone')" :value="order.phone"
        class="sf-property--full-width property" />
      <SfProperty :name="$t('Shipping_title')" :value="getShippingInfo(order)"
        class="sf-property--full-width property" />
      <SfProperty :name="$t('payment_order_note')" :value="order.memberNote" class="sf-property--full-width property" />
      <template v-if="wuliuList && wuliuList.length">
        <template v-for="wuliu in wuliuList">
          <SfProperty :key="'shippingCorp' + wuliu.Id" v-if="wuliu.shippingCorp" :name="$t('Order_logisticsName')"
            :value="wuliu.shippingCorp" class="sf-property--full-width property" />
          <SfProperty :key="'shippingCode' + wuliu.Id" v-if="wuliu.shippingCode" :name="$t('Order_logisticsNo')"
            :value="wuliu.shippingCode" class="sf-property--full-width property" />
        </template>
      </template>
      <template v-else>
        <SfProperty v-if="order.logisticsName" :name="$t('Order_logisticsName')" :value="order.logisticsName"
          class="sf-property--full-width property" />
        <SfProperty v-if="order.shipmentId" :name="$t('Order_logisticsNo')" :value="order.shipmentId"
          class="sf-property--full-width property" />
      </template>
      <SfProperty v-if="orderGetters.getStatus(order) == 'ORDER_WAIT_PAYMENT'" :name="$t('Pay_Order')"
        class="sf-property--full-width property">
        <template #value>
          <SfLink href="#" @click="orderGoPay()" link="">
            {{ $t('go_pay_order') }}
          </SfLink>
        </template>
      </SfProperty>
      <AfterSales v-if="orderGetters.getStatus(order) !== 'ORDER_WAIT_PAYMENT' && orderGetters.getStatus(order) !== 'ORDER_CLOSED' &&
        shouhouShowStatus !== '0'
        " :order="order" @applyOk="applyOk"></AfterSales>
      <orderReivice v-if="orderGetters.getStatus(order) === 'ORDER_WAIT_RECEIPT'" @ok="orrderReiviceBack" :orderId="orderGetters.getId(order)" />
    </div>
    <div v-if="aftersalesList && order && type == 'shouhou'">
      <div v-for="(afterSale, index) in aftersalesList" :key="index">
        <div class="highlighted highlighted--total">
          <SfProperty :name="$t('after_sales_Id')" :value="afterSale.after_sale_id"
            class="sf-property--full-width property" />
          <SfProperty :name="$t('Order_No')" :value="afterSale.order_id" class="sf-property--full-width property" />
          <div class="AfterItem">
            <SfTable class="products">
              <SfTableHeading>
                <SfTableHeader class="products__name">{{
                  $t('Product')
                  }}</SfTableHeader>
                <SfTableHeader>{{ $t('Quantity') }}</SfTableHeader>
                <SfTableHeader>{{ $t('Price') }}</SfTableHeader>
              </SfTableHeading>
              <template v-for="(item, i) in afterSale.after_sale_item">
                <SfTableRow :key="i">
                  <SfTableData class="products__name">
                    <div style="display:flex;">
                      <SfImage :src="(item.img_url)" :alt="item.title" class="orderImg" />
                      <!-- <nuxt-link :to="'/p/' +
                          item.good_id +
                          '/a'
                          "> -->
                      {{ orderGetters.getItemName(item) }}
                      <div v-if="orderGetters.getItemAttributes(item)" style="font-size:12px">
                        <span v-for="(skuPropKey,skuPropValue) in orderGetters.getItemAttributes(item)">
                          {{ skuPropKey }}:{{ skuPropValue }}
                        </span>
                      </div>
                      <!-- </nuxt-link> -->
                    </div>
                    <!-- <nuxt-link :to="'/p/'+orderGetters.getGoodId(item)+'/'+orderGetters.getItemSku(item)"> -->
                    <!-- {{ orderGetters.getItemName(item) }} -->
                    <!-- </nuxt-link> -->
                  </SfTableData>
                  <SfTableData>{{ orderGetters.getItemQty(item) }}</SfTableData>
                  <SfTableData>{{
                    $n(item.amount, {
                    style: 'currency',
                    currency: order.transCurrency,
                    })
                    }}</SfTableData>
                </SfTableRow>
                <template v-if="afterSale && afterSale.service_order">
                  <SfTableRow v-for="serviceOrder in afterSale.service_order" :key="serviceOrder.service_order_id">
                    <SfTableData class="products__name">
                      {{ serviceOrder.service_name }}
                    </SfTableData>
                    <SfTableData>
                    </SfTableData>
                    <SfTableData></SfTableData>
                    <SfTableData></SfTableData>
                    <SfTableData>
                      {{ $n(serviceOrder.trans_amount, {
                      style: 'currency',
                      currency: serviceOrder.trans_currency || '',
                      }) }}
                    </SfTableData>
                    <SfTableData></SfTableData>
                  </SfTableRow>
                </template>
              </template>
            </SfTable>
          </div>
          <SfProperty :name="$t('after_sales_status')" :value="$t(afterSale.status)"
            class="sf-property--full-width property" />
          <SfProperty :name="$t('after_sales_Reason')" :value="afterSale.reason"
            class="sf-property--full-width property" />
          <SfProperty :name="$t('Total')" :value="$n(afterSale.refund_amt, {
            style: 'currency',
            currency: order.transCurrency,
          })
            " class="sf-property--full-width property" />
          <SfProperty :name="$t('after_sales_refund')" class="sf-property--full-width property">
            <template #value>
              <SfLink href="#" @click="refund({ after_sale_id: afterSale.after_sale_id })" link="">
                {{ $t('after_sales_refund_order') }}
              </SfLink>
            </template>
          </SfProperty>
          <!-- <SfProperty v-if="orderGetters.getStatus(order) == 'ORDER_WAIT_PAYMENT'" :name="$t('Pay_Order')"
            class="sf-property--full-width property">
            <template #value>
              <SfLink href="#" @click="orderGoPay(order)" link="">
                {{ $t('go_pay_order') }}
              </SfLink>
            </template>
          </SfProperty> -->
          <!-- <AfterSales v-if="orderGetters.getStatus(order)!=='ORDER_WAIT_PAYMENT' && orderGetters.getStatus(order)!=='ORDER_AFTER_SALE'" :order="order"></AfterSales> -->
        </div>
      </div>
    </div>
    <div v-if="order && type=='order'">
      <SfTable class="products">
        <SfTableHeading>
          <SfTableHeader class="products__name">{{
            $t('Product')
            }}</SfTableHeader>
          <SfTableHeader>{{ $t('Quantity') }}</SfTableHeader>
          <SfTableHeader>{{ $t('Price') }}</SfTableHeader>
          <SfTableHeader>{{ $t('Discount') }}</SfTableHeader>
          <SfTableHeader>{{ $t('Total_price') }}</SfTableHeader>
          <SfTableHeader>{{ $t('Review') }}</SfTableHeader>
        </SfTableHeading>
        <template v-for="(item, i) in orderGetters.getItems(order)">
          <SfTableRow :key="i">
            <SfTableData class="products__name">
              <div class="orderGoodsItem">
                <nuxt-link :to="localePath('/p/' +
                  orderGetters.getGoodId(item) +
                  '/' +  orderGetters.getItemName(item))">
                  <SfImage :src="(item.imgUrl)" :alt="item.title" class="orderImg" />
                </nuxt-link>
                <div>
                  <nuxt-link :to="localePath('/p/' +
                    orderGetters.getGoodId(item) +
                    '/' +  orderGetters.getItemName(item))">
                    {{ orderGetters.getItemName(item) }}
                  </nuxt-link>
                  <div v-if="orderGetters.getItemAttributes(item)" style="font-size:12px;">
                    <span v-for="(skuPropKey, skuPropValue) in orderGetters.getItemAttributes(item)">
                      {{ skuPropKey }}:{{ skuPropValue }}
                    </span>
                  </div>
                </div>
              </div>
            </SfTableData>
            <SfTableData>{{ orderGetters.getItemQty(item) }}</SfTableData>
            <SfTableData>
              {{
              $n(orderGetters.getItemPrice(item), {
              style: 'currency',
              currency: order.transCurrency || '',
              })
              }}
            </SfTableData>
            <SfTableData>
              {{
              $n(item.discount, {
              style: 'currency',
              currency: order.transCurrency || '',
              })
              }}
            </SfTableData>
            <SfTableData>
              {{
              $n(item.totalPayment, {
              style: 'currency',
              currency: order.transCurrency || '',
              })
              }}
            </SfTableData>
            <SfTableData>
              <Review v-if="orderGetters.getStatus(order) === 'ORDER_WAIT_RATE' " :order="order" :goodsId="orderGetters.getGoodId(item)" :skuId="orderGetters.getItemSku(item)"
                :itemName="orderGetters.getItemName(item)"></Review>
            </SfTableData>
          </SfTableRow>
          <div>
            <ReviewContent :order="order" :goodsId="orderGetters.getGoodId(item)" :skuId="orderGetters.getItemSku(item)"
                :itemName="orderGetters.getItemName(item)" style="margin-top:1rem;"></ReviewContent>
          </div>
          <SfTableRow v-for="serviceOrder in order.serviceOrder" :key="serviceOrder.service_order_id">
            <SfTableData class="products__name">
              {{ serviceOrder.service_name }}
            </SfTableData>
            <SfTableData>
            </SfTableData>
            <SfTableData></SfTableData>
            <SfTableData></SfTableData>
            <SfTableData>
              {{ $n(serviceOrder.trans_amount, {
              style: 'currency',
              currency: serviceOrder.trans_currency || '',
              }) }}
            </SfTableData>
            <SfTableData></SfTableData>
          </SfTableRow>
        </template>
      </SfTable>
    </div>
    <div v-if="wuliuList && wuliuList.length">
      <div v-for="wuliu in wuliuList">
        <div style="margin-top:1rem;font-weight:600;">{{ $t('shippingInfo') }}: </div>
        <div style="margin-top:0.25rem;">
          <SfProperty :name="wuliu.shippingCorp" :value="wuliu.shippingCode" class="sf-property--full-width property" />
        </div>
        <div class="shippingItems">
          <div v-for="item in wuliu.details" :key="item.sku_id">
            <SfProductCard :image="item.img_url" :title="item.title" :wishlistIcon="false" :showAddToCartButton="false"
              :scoreRating="false">
              <template #image>
                <div class="shippingOrderImg">
                  <SfImage :src="item.img_url" :alt="item.title" />
                </div>
              </template>
              <template #title>
                <div class="shippingTitle">
                  <div>{{ item.title }}</div>
                  <div v-if="getItemAttributes(item.sku_prop)" style="font-size:12px;">
                    <span v-for="(skuPropKey, skuPropValue) in getItemAttributes(item.sku_prop)">
                      {{ skuPropKey }}:{{ skuPropValue }}
                    </span>
                  </div>
                  <div>{{ $t('shippingItemQty') }}: {{ item.num }}</div>
                </div>
              </template>
            </SfProductCard>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  SfTable,
  SfButton,
  SfProperty,
  SfLink,
  SfImage,
  SfProductCard
} from '@storefront-ui/vue';
import AfterSales from '~/components/Order/AfterSales';
import { orderGetters, useUserShouHouList, useShouHou, useCredential, useWayBillList, useOrderDetail, useOrderReceiving } from '@bee-hole/coms';
import { onSSR } from '@vue-storefront/core';
import { useRouter, computed, onMounted } from '@nuxtjs/composition-api';
import orderItemGtter from '~/plugins/orderItemGtter.js';
import Review from '~/components/Order/Review';
import ReviewContent from '~/components/Order/ReviewContent';
import orderReivice from '~/components/Order/orderReivice';
export default {
  name: 'afterSalesDetail',
  props: {
    curOrder: {
      type: Object,
      default: {}
    },
    type: {
      type: String,
      default: 'order'
    },
    preOrderId: {
      type: String,
      default: ''
    }
  },
  components: {
    AfterSales,
    SfTable,
    SfButton,
    SfProperty,
    SfLink,
    SfImage,
    Review,
    SfProductCard,
    ReviewContent,
    orderReivice
  },
  setup(prop, { root, emit }) {
    // const previewOrderStore = usePreviewOrderStore();
    const { getPinJu, result: pingju } = useCredential();
    const { orderOne, order } = useOrderDetail();
    const { shouhouGet, aftersalesList } = useUserShouHouList(orderGetters.getId(prop.curOrder));
    const { refund } = useShouHou(orderGetters.getId(prop.curOrder));
    const { result: wuliuList, wayBillList } = useWayBillList(orderGetters.getId(prop.curOrder));
    const { orderReceiving } = useOrderReceiving('orderReceiving');
    const router = useRouter();
    const shouhouShowStatus = computed(() => {
      if (typeof root?.$options?.$storeConfig?.mall_shouhou_config === 'number') {
        return root?.$options?.$storeConfig?.mall_shouhou_config;
      } else {
        return root?.$options?.$storeConfig?.mall_shouhou_config?.showshouhou;
      }
    });
    const getCuurentDate = root?.$options?.getCuurentDate;
    orderOne({ order_id: prop?.curOrder?.orderId });
    onSSR(async () => {
      // await orderOne({ order_id: prop?.curOrder?.orderId });
      await shouhouGet({ order_id: prop?.curOrder?.orderId });
    });
    const orderGoPay = async () => {
      // previewOrderStore.setOrder(order);
      // router.push(root.localePath(`/xpay?orderNumber=${orderGetters.getId(order)}`));
      await getPinJu({ prepay_id: prop.preOrderId });
      if (pingju.value?.credential_id) {
        const transformedPath = `/xpay?orderNumber=${prop.preOrderId}&credential_id=${pingju.value?.credential_id}`;
        router.push(root.localePath(transformedPath));
      }
    };
    const applyOk = async () => {
      // 申请售后成功返回
      await orderOne({ order_id: prop?.curOrder?.orderId });
      emit('applyOk');
    };
    onMounted(async () => {
      await shouhouGet({ order_id: prop?.curOrder?.orderId });
      await wayBillList({ order_id: prop?.curOrder?.orderId });
      // await orderOne({ order_id: prop?.curOrder?.orderId });
    });
    const getItemAttributes = (skuProp) => {
      if (skuProp && skuProp.indexOf('{') !== -1) {
        return JSON.parse(skuProp);
      }
      return '';
    };
    const orrderReiviceBack = async () => {
      await orderOne({ order_id: prop?.curOrder?.orderId });
    };
    return {
      orderGetters,
      aftersalesList,
      refund,
      orderGoPay,
      getCuurentDate,
      shouhouShowStatus,
      ...(orderItemGtter),
      wuliuList,
      order,
      applyOk,
      getItemAttributes,
      orrderReiviceBack
    };
  }
};
</script>
<style lang="scss" scoped>
.orderImg {
    width: 5rem;
    --_image-width: 5rem;
    margin:0;
    margin-right:1rem;
    .sf-image {
    width: 5rem;
    }
}
.highlighted {
  box-sizing: border-box;
  width: 100%;
  background-color: var(--c-light);
  padding: var(--spacer-sm);
  --property-value-font-size: var(--font-size--base);
  --property-name-font-size: var(--font-size--base);

  &:last-child {
    margin-bottom: 0;
  }

  ::v-deep .sf-property__name {
    white-space: nowrap;
  }

  ::v-deep .sf-property__value {
    text-align: right;
  }

  &--total {
    margin-bottom: var(--spacer-sm);
  }

  @include for-desktop {
    padding: var(--spacer-xl);
    --property-name-font-size: var(--font-size--lg);
    --property-name-font-weight: var(--font-weight--medium);
    --property-value-font-size: var(--font-size--lg);
    --property-value-font-weight: var(--font-weight--semibold);
  }
}

.AfterItem {
  margin-bottom: 20px;
}
.shippingOrderImg{
  display: flex;
  justify-content: center;
  @include for-mobile {
    --_image-width: 40vw;
  }
  @include for-desktop {
    --_image-width: auto;
    --_image-height: 120px;
  }
}
.shippingItems{
  display: flex;
  flex-wrap: wrap;
  @include for-mobile {
      justify-content: space-between;
  }
}
.shippingTitle{
  @include for-mobile {
    // font-size: 12px;
    width:40vw;
  }
  @include for-desktop {
    // font-size: 16px;
    width: 120px;
  }
}
.orderGoodsItem{
  display: flex;
  @include for-mobile {
    flex-direction: column;
  }
  @include for-desktop {
    flex-direction: row;
    flex-wrap: wrap;
  }
}
</style>
